import { cache } from '@/container/apollo-client/cache';
import {
  RecentMessageConversation,
  useReadAllMessageMutation,
  useReadMessageMutation,
} from '@/types/generated/graphql';
import { gql } from '@apollo/client';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// triggered on `new messsage` if conversation is open
export function useReadMessage() {
  const [readMessage] = useReadMessageMutation();

  function readMessageHandler(messageConversationId: number) {
    readMessage({
      variables: {
        messageConversationId,
      },
    });
  }

  return {
    readMessage: readMessageHandler,
  };
}

// triggered on conversation visit
export function useReadAllMessage() {
  const { channelId = '', clientId = '' } = useParams();
  const recentMessageId = `RecentMessageConversation:{"client":{"id":${clientId}},"channel":{"id":${channelId}}}`;

  const [readAllMessage] = useReadAllMessageMutation({
    onCompleted: () => {
      cache.writeFragment<Pick<RecentMessageConversation, 'unreadCounter' | 'lastReadCursor'>>({
        id: recentMessageId,
        fragment: FRAGMENT_RECENT_MESSAGE,
        data: {
          unreadCounter: 0,
          lastReadCursor: null,
        },
      });
    },
  });

  function readMessageHandler() {
    const recentMessageFragment = cache.readFragment<Pick<RecentMessageConversation, 'id' | 'unreadCounter'>>({
      id: recentMessageId,
      fragment: FRAGMENT_RECENT_MESSAGE,
    });

    if (recentMessageFragment?.unreadCounter) {
      readAllMessage({
        variables: {
          recentMessageConversationId: recentMessageFragment?.id,
        },
      });
    }
  }

  useEffect(readMessageHandler, [recentMessageId]);

  return {
    readMessage: readMessageHandler,
  };
}

const FRAGMENT_RECENT_MESSAGE = gql`
  fragment ReadRecentMessage on RecentMessageConversation {
    id
    unreadCounter
    lastReadCursor
  }
`;
